import { h, Host } from "@stencil/core";
export class TableRowNeo {
    constructor() {
        this.direction = undefined;
    }
    host;
    render() {
        return (h(Host, { key: 'ef26dd6301ee0580a9f7e1034c5cd1260cbea75f' }, h("ux-icon", { key: '51d3ef9dbceb06ec923641ff59c91ddfe3f403af', fill: this.direction === "ascending" ? "white" : undefined, name: "chevron-up" }), h("ux-icon", { key: '13f0a3b9a4233b9050fede96dfcc5e750cac7f6e', fill: this.direction === "descending" ? "white" : undefined, name: "chevron-down" })));
    }
    static get is() { return "ux-table-cell-sort-neo"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["table-cell-sort-neo.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["table-cell-sort-neo.css"]
        };
    }
    static get properties() {
        return {
            "direction": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "SortDirection",
                    "resolved": "\"ascending\" | \"descending\" | \"none\"",
                    "references": {
                        "SortDirection": {
                            "location": "import",
                            "path": "../../interfaces/directions",
                            "id": "src/components/table-neo/interfaces/directions.ts::SortDirection"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The direction of the sort"
                },
                "attribute": "direction",
                "reflect": false
            }
        };
    }
    static get elementRef() { return "host"; }
}
//# sourceMappingURL=table-cell-sort-neo.js.map
